import { apiClient } from '@/shared/api/api-client'
import { IAppInfo } from '@/shared/model/types/app-info'

export const getAppInfo = async (url: string) => {
	const data = await apiClient.get<IAppInfo>('info', {
		baseURL: url
	})
	return data
}
